import React from "react";
import { Link } from "react-router-dom";
import "./nav.css";

export default function CMSNav() {
  return (
    <div className="nav-buttons">
      <Link to="/cms" className="nav-btn"> داشبورد</Link>
      <Link to="/cms/products" className="nav-btn"> محصولات</Link>
      <Link to="/cms/add-product" className="nav-btn"> افزودن محصول</Link>
      <Link to="/cms/categories" className="nav-btn"> دسته‌بندی‌ها</Link>
      <Link to="/cms/blogs" className="nav-btn"> بلاگ‌ها</Link>

      <Link to="/cms/users" className="nav-btn"> کاربران</Link>
      <Link to="/cms/orders" className="nav-btn"> سفارش‌ها</Link>
    </div>
  );
}
